export default {
  GET_TABLE_DATA: (state) => state.tableData
};
